import Title from "./components/Title/Title";
import Paragraph from "./components/Paragraph/Paragraph";
import Button from "./components/Button/Button";
import OptionsItem from "./components/OptionsItem/OptionsItem";
import React, { useEffect, useState } from "react";
import imageStartScreen from "./assets/images/00.webp";
import imageResult from "./assets/images/9.webp";
import styles from "./App.module.scss";
import questions from "./state/questions";
import classNames from "classnames";
import Result from "./components/Result/Result";

function App() {
  const [currentQuestion, setCurrentQuestion] = useState(0); // считаем номер вопроса
  const [stateFlow, setStateFlow] = useState("Start"); // состояние флоу: стартовый экран / вопросы / результат
  const [option, setOption] = useState(false); // выбран ли ответ
  const [resultState, setResultState] = useState(""); // выводить ли результат
  const [resultCount, setResultCount] = useState(0); // счетчик правильных вопросов
  const phone = document.getElementById("phone"); // находим область телефона на десктопе

  // console.log(resultCount); // тестирование логики

  // прокрутка вниз при нажатии на ответ
  const optionActiveHandler = (option) => {
    setOption(option);

    setTimeout(() => {
      window.scrollTo({ top: 1000, behavior: "smooth" });
      phone.scrollTo({ top: 1000, behavior: "smooth" });
    }, "50");
  };

  const resultCountLogic = (result) => {
    setResultCount(resultCount + result);
  };

  // поднимаемся наверх после перехода на страницу
  const scrollReset = (event) => {
    window.scrollTo(0, 0);
    phone.scrollTo(0, 0);
  };

  // Скролл наверх при нажатии старт квиз
  const startFlow = () => {
    setStateFlow("Flow");
    window.scrollTo(0, 0);
  };

  // логика флоу
  const handlerNext = () => {
    if (currentQuestion === 5) {
      setStateFlow("End");

      setResultState(() => {
        if (resultCount <= 2) {
          return (
            <Result
              score={resultCount + "/6"}
              title="คุณยังต้องเรียนรู้เรื่องเทรนด์แฟชันอีกเยอะเลย! ถ้างั้นก็อย่ารอช้า"
              text={
                "รีบกดเพื่อรับโค้ดส่วนลดเพื่อเลือกซื้อสินค้าสุดเอ็กส์คลูซีฟของ Maxim และรับส่วนลดสูงสุดถึง 10% อยากได้สินค้าชิ้นไหนสามารถจิ้มเลือกได้เลย Shopee"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 3 && resultCount <= 4) {
          return (
            <Result
              score={resultCount + "/6"}
              title="โลกแฟชันหมุนเร็วกว่าที่คุณคิด อย่าปล่อยให้ตัวเองตกเทรนด์ มาอัปเดตความรู้แล้วก้าวไปข้างหน้าด้วยกัน!"
              text={
                "รีบเลย! ใช้งานโค้ดโปรโมชันและเลือกซื้อสินค้าจากแบรนด์ของเรา รับส่วนลด 10% สำหรับสินค้าของ Maxim เลือกซื้อสินค้าของแท้จากบริการของเราผ่าน Shopee ได้แล้ววันนี้!"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 5 && resultCount <= 6) {
          return (
            <Result
              score={resultCount + "/6"}
              title="คุณยังต้องเรียนรู้เรื่องเทรนด์แฟชันอีกเยอะเลย! ถ้างั้นก็อย่ารอช้า"
              text={
                "รีบกดเพื่อรับโค้ดส่วนลดเพื่อเลือกซื้อสินค้าสุดเอ็กส์คลูซีฟของ Maxim และรับส่วนลดสูงสุดถึง 10% อยากได้สินค้าชิ้นไหนสามารถจิ้มเลือกได้เลย Shopee"
              }
              imageSrc={imageResult}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }
      });

      // сбрасываем  скролл для результата
      scrollReset();
    } else {
      setOption(false);
      setCurrentQuestion(currentQuestion + 1);

      // прокрутка вверх после нажатия на ответ
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        phone.scrollTo({ top: 0, behavior: "smooth" });
      }, "50");
    }
  };

  // возвращение в начало
  const handlerBack = () => {
    setOption(false);
    setStateFlow("Start");
    setCurrentQuestion(0);
    setResultCount(0);
  };

  // считаем цифры прокрутки и верешаем options::after
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const handleScroll = (event) => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.wrapperContainer}>
      <div className={styles.wrapper}>
        <div className={styles.phone} id="phone">
          {stateFlow === "Start" ? (
            <>
              <div className={styles.posterContainer}>
                <img src={imageStartScreen} className={styles.image} alt="" />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.contentWrapper}>
                    <Title value="แค่ตอบคำถามเกี่ยวกับความรู้ทั่วไปในชีวิตประจำวันแล้วรับรางวัลไปเลย!" />
                    <Paragraph value="จริงหรือไม่ที่ว่าหมวกกันน็อคนั้นมีประวัติการถูกใช้งานมาเป็นร้อยๆปีแล้ว และจริงหรือไม่ที่ว่าเสื้อแขนยาวที่สวมใส่กันทุกวันนั้น ที่จริงแล้วจะมีสีตั้งต้นเป็นสีขาว มาทดสอบความรู้ทั่วไปของคุณด้วยการตอบคำถาม 6 ข้อนี้เลย" />
                    <Paragraph value="เมื่อตอบคำถามครบ 6 ข้อแล้ว ก็รับไปเลย! โค้ดส่วนลดสุดพิเศษสำหรับซื้อยูนิฟอร์มและสินค้าอื่นๆของ Maxim บน Shopee!" />
                  </div>
                  <Button
                    value="เริ่มตอบคำถาม"
                    onClick={() => startFlow()}
                    id="start"
                  />
                </div>
              </div>
            </>
          ) : stateFlow === "Flow" ? (
            <>
              <div className={styles.posterContainer}>
                <img
                  src={questions[currentQuestion].image}
                  className={styles.image}
                  alt={questions[currentQuestion].image}
                />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.header}>
                    <div className={styles.topBarContainer}>
                      <div>
                        คำถาม {currentQuestion + 1} จาก {questions.length}
                      </div>
                    </div>
                    <div>
                      <div className={styles.headerDesc}>
                        <Title
                          value={questions[currentQuestion].questionDesc}
                        />
                      </div>
                    </div>
                    <Title value={questions[currentQuestion].questionText} />
                  </div>

                  <div className={styles.optionsWrapper}>
                    {questions[currentQuestion].answerOptions.map((item) => (
                      <OptionsItem
                        key={item.answerText}
                        title={item.answerText}
                        resultText={item.answerResult}
                        onClick={optionActiveHandler}
                        disabled={option}
                        result={item.result}
                        resultCountLogic={resultCountLogic}
                      />
                    ))}
                  </div>

                  <Button
                    value="ถัดไป"
                    onClick={() => handlerNext()}
                    disabled={!option}
                    id={"btn" + (currentQuestion + 1)}
                  />
                </div>
              </div>
            </>
          ) : (
            <>{resultState}</>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
